import { render, staticRenderFns } from "./HeaderNotificationsLink.vue?vue&type=template&id=b46ce25c&scoped=true"
import script from "./HeaderNotificationsLink.vue?vue&type=script&lang=js"
export * from "./HeaderNotificationsLink.vue?vue&type=script&lang=js"
import style0 from "./HeaderNotificationsLink.vue?vue&type=style&index=0&id=b46ce25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46ce25c",
  null
  
)

export default component.exports